import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { useSelector } from "react-redux";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import DailyStatus from "../DailyStatus";
import WorkReport from "../WorkReport";
import "../../assets/scss/tables.scss";

/* Both report screens live here now. The old paths still resolve — the team
   one simply opens on its own tab — so existing links and notification deep
   links keep working. */
const Panel = ({ children, value, index }) => (
    <div role="tabpanel" hidden={value !== index}
        id={`work-reports-panel-${index}`}
        aria-labelledby={`work-reports-tab-${index}`}>
        {value === index && <Box sx={{ pt: 2 }}>{children}</Box>}
    </div>
);

const WorkReports = () => {

    const location = useLocation();

    const { user } = useSelector((state) => state.WorkHubAppSlice);
    const canSeeTeam = Boolean(user?.roles?.isTeam);

    /* /work-report opens on the team tab, /status-report on mine */
    const [value, setValue] = useState(
        canSeeTeam && location.pathname.startsWith("/work-report") ? 1 : 0);

    return (
        <div className="wh-table work-reports-page">
            <Tabs value={value} onChange={(e, v) => setValue(v)}
                aria-label="work reports" className="wh-tabs">
                <Tab label="My Work Reports" disableRipple
                    icon={<DescriptionOutlinedIcon />} iconPosition="start"
                    id="work-reports-tab-0" aria-controls="work-reports-panel-0" />
                {canSeeTeam && <Tab label="Team Work Reports" disableRipple
                    icon={<GroupsOutlinedIcon />} iconPosition="start"
                    id="work-reports-tab-1" aria-controls="work-reports-panel-1" />}
            </Tabs>

            <Panel value={value} index={0}><DailyStatus /></Panel>
            {canSeeTeam && <Panel value={value} index={1}><WorkReport /></Panel>}
        </div>
    );
};

export default WorkReports;
